export default "__VITE_ASSET__DUY5CJ65__"